import flowSensorApi from '@/api/config/flowSensorApi'
import { queryKeys } from '@/constant/common'
import { APIResponseList } from '@/types'
import { FlowSensorType } from '@/types/hydraulic'
import { QueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query'

function useSearchFlowSensor(
  interfaceId: number,
  queryOptions?: QueryOptions,
): UseQueryResult<APIResponseList<FlowSensorType>, any> {
  return useQuery(
    [queryKeys.flowSensor],
    async () => {
      const { data } = await flowSensorApi.getAll({
        interfaceId,
      })

      if (!data) return null

      return {
        list: data.data,
        page: data.page,
        size: data.size,
        sort: data.sort,
        totalCount: data.totalCount,
        totalPage: data.totalPage,
      }
    },
    queryOptions,
  )
}

export default useSearchFlowSensor
